import styled from "styled-components";

export const Error = styled.p`
  color: red;
  font-size: 1.4rem;
  margin-top: 0.2rem;
  z-index: 9;
`;

export const WidthLimiter = styled.section`
  max-width: 800px;
`;

export const FullHeighit= styled.div`
  height: calc(100% - 50px);
`
export const BottonWrapper = styled.div`
  position: absolute;
  bottom: 15px;
  width: -webkit-fill-available;
  max-width: 800px
`
